var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUploadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 79,
    viewBox: "0 0 84 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7474 52.5833V38.0833L39.9141 42.9166",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.75 38.0833L49.5833 42.9166",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1693 33.6666V45.7499C69.1693 57.8332 64.3359 62.6666 52.2526 62.6666H37.7526C25.6693 62.6666 20.8359 57.8332 20.8359 45.7499V31.2499C20.8359 19.1666 25.6693 14.3333 37.7526 14.3333H49.8359",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1693 33.6666H59.5026C52.2526 33.6666 49.8359 31.2499 49.8359 23.9999V14.3333L69.1693 33.6666Z",
    stroke: "#8898CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 60,
    r: 19,
    fill: "#209765"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63281 61.3381L16.323 68.5635L30.5061 54.3804",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadSuccess);
export default __webpack_public_path__ + "static/media/file-upload-success.0c2b18734df19957a955f1e56da59dcc.svg";
export { ForwardRef as ReactComponent };